import { useEffect, useContext, useCallback } from "react";

import StepsPagination from "../Content/StepsPagination";
import StepsHeadline from "../Content/StepsHeadline";
import StepsForm from "../Content/StepsForm";
import RadioCard from "../Content/RadioCard";
import HelperText from "../Content/HelperText";

import CalculatorContext from "../../Context/CalculatorContext";

/* eslint-disable max-len */
function StepOnePage() {
  const { setCurrentStepIndex, forecastStartYear, setForecastStartYear } =
    useContext(CalculatorContext);

  useEffect(() => {
    setCurrentStepIndex(0);
  }, [setCurrentStepIndex]);

  const onForecastStartYearChange = useCallback(
    (e) => {
      setForecastStartYear(e.target.value);
    },
    [setForecastStartYear],
  );

  const year = new Date().getFullYear();

  return (
    <div className="tx-kalo form-steps-abwizard form-steps-abwizard-transparent">
      <div className="frame frame-size-default frame-full frame-background-tertiary">
        <div className="frame-group-container">
          <div className="frame-container frame-container-default">
            <div className="frame-inner frame-inner-space-before-extra-small frame-inner-space-after-medium">
              <StepsPagination />

              <StepsHeadline>
                <h1 className="element-header text-center h4">
                  Bitte geben Sie an, für welches Jahr die{" "}
                  <span className="text-primary">
                    CO<sub>2</sub>-Kostenprognose
                  </span>{" "}
                  erstellt werden soll.
                </h1>
              </StepsHeadline>

              <div className="frame frame-size-default frame-indent-8 frame-space-after-extra-small">
                <div className="frame-container frame-container-default">
                  <div className="frame-inner">
                    <div className="tx-powermail">
                      <div className="wrap-fluid">
                        <StepsForm>
                          <fieldset className="powermail_fieldset">
                            <div className="row justify-content-center">
                              <div className="col-md-9 col-lg-8 text-center">
                                <fieldset className="form-group">
                                  <div className="form-group">
                                    <div className="form-group-custom-radio">
                                      <RadioCard
                                        id="forecast_start_year_1"
                                        image={null}
                                        label={`<div class='radio-card-no-image-label'><h4 class='m-0'>${(
                                          year - 1
                                        ).toString()}</h4></div>`}
                                        value={(year - 1).toString()}
                                        checked={forecastStartYear === (year - 1).toString()}
                                        onChange={onForecastStartYearChange}
                                      />
                                      <RadioCard
                                        id="forecast_start_year_0"
                                        image={null}
                                        label={`<div class='radio-card-no-image-label'><h4 class='m-0'>${year.toString()}</h4></div>`}
                                        value={year.toString()}
                                        checked={forecastStartYear === year.toString()}
                                        onChange={onForecastStartYearChange}
                                      />
                                    </div>
                                  </div>
                                </fieldset>

                                <div className="form-group pt-4 pt-md-3">
                                  <input
                                    className="btn btn-secondary"
                                    type="submit"
                                    value="Weiter"
                                    disabled={forecastStartYear === ""}
                                  />
                                </div>
                              </div>
                            </div>
                          </fieldset>
                        </StepsForm>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <HelperText>
                <p>
                  Wenn Sie {year} auswählen, wird das Jahr {year - 1} nicht in der Kostenprognose
                  berücksichtigt. Die Prognose wird in beiden Fällen für einen Zeitraum von 10
                  Jahren erstellt.
                </p>
              </HelperText>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default StepOnePage;
